import React from "react";
import "./dashboard-header.scss";
import { Container } from "react-bootstrap";

const DashboardHeader = () => {
  return (
    <Container fluid className="header-icons mt-4">
      {/* Geri butonu kaldırıldı */}
    </Container>
  );
};

export default DashboardHeader;
